import moment from "moment";

//! @ngInject
export function billingPayrollDetailsCtrl(Consts, $http, $scope, $rootScope, NgTableParams, ngTableEventsChannel, $stateParams, DatabaseApi, toaster, selectionLogic, wildcard, $uibModal, mfModal, patientLookupService) {
    const universalBOM = "\uFEFF";
    $scope.isLoadingPayrollItems = false;
    $scope.payrollBatch = null;
    $scope.caregiversVisits = {};
    $scope.contracts = DatabaseApi.contractTypes();
    $scope.serviceCodes = DatabaseApi.activeServiceCodes();
    $scope.serviceCodesOptions = $scope.serviceCodes.map(sc => ({ id: sc.id, label: sc.code }));

    $scope.visitPayrollTypesMap = {
        "PTO": "PTO",
        "ONLINE_TRAINING": "Online Training",
        "IN_CLASS": "In Class",
        "TRAVEL_TIME": "Travel Time",
        "SOH": "SOH",
        "VISIT": "Visit"
    }
    $scope.visitTypeOptions = Object.keys($scope.visitPayrollTypesMap)
        .map((key, index) => ({ id: index, label: $scope.visitPayrollTypesMap[key], type: key }));

    $scope.billingPayrollDetailsFilters = {
        serviceCodes: [],
        visitTypes: [],
        isOldVisit: "",
        isOvertimeVisit: ""
    };
    $scope.filteredPayrollItems = [];
    $scope.filteredPayrollSelection = { areAllSelected: false };

    const updateFilteredPayrollItemsSelection = function () {
        $scope.filteredPayrollSelection.areAllSelected =
            $scope.filteredPayrollItems.length > 0 &&
            $scope.filteredPayrollItems.every(item => item.isSelected);
    };

    $scope.toggleAllFilteredPayrollItems = function () {
        // toggleAllItemsInCollection uses this value as the target selection state.
        $scope.selectionLogic.data.areAllItemsSelected =
            $scope.filteredPayrollSelection.areAllSelected;
        $scope.selectionLogic.toggleAllItemsInCollection($scope.filteredPayrollItems);
        $scope.selectionLogic.refreshIfAllItemsSelected();
    };

    $scope.onPayrollItemSelectionChanged = function (item) {
        $scope.selectionLogic.onItemSelectionChanged(item);
        updateFilteredPayrollItemsSelection();
    };

    ngTableEventsChannel.onAfterDataFiltered(function (_publisher, tableParams, filteredItems) {
        if (tableParams === $scope.billingPayrollTable) {
            $scope.filteredPayrollItems = filteredItems;
            updateFilteredPayrollItemsSelection();
        }
    }, $scope);

    const initialize = function () {
        // DECIDE WHETHER DRAFT OR SELECTED VISIT
        if ($stateParams.isDraft === true) {
            $scope.isDraft = true;
            if ($stateParams.payrollBatchWithVisits) {
                $scope.payrollBatch = $stateParams.payrollBatchWithVisits.payrollBatch;
                $scope.payrollItems = $stateParams.payrollBatchWithVisits.payrollItems;
                initSelectionLogic($scope.payrollItems);
                filterBillingPayrollTable();
            } else {
                $scope.payrollBatch = $stateParams.payrollBatch;
                loadCaregiverPayrolls($stateParams.id);
            }
        } else {
            if ($stateParams.id) {
                loadCaregiverPayrolls($stateParams.id);
            }
        }
    }

    const initSelectionLogic = function (data) {
        $scope.selectionLogic = selectionLogic.createNewLogic((item) => {
            $scope.selectionLogic.addItemToCollection(item);
        });

        data.forEach(pv => {
            $scope.selectionLogic.initItem(pv);
        });

        $scope.missingIssuesSettingsCount = data.filter(pv => pv.missingIssuesSettings === true).length;

        $scope.selectionLogic.data.areAllItemsSelected = true;
        $scope.selectionLogic.toggleAllItems();
    };

    // Like initSelectionLogic, but keeps each item's current selection.
    const rebuildSelectionLogic = function (data) {
        $scope.selectionLogic = selectionLogic.createNewLogic((item) => {
            $scope.selectionLogic.addItemToCollection(item);
        });

        data.forEach(pv => {
            $scope.selectionLogic.initItem(pv, pv.isSelected);
        });

        $scope.missingIssuesSettingsCount = data.filter(pv => pv.missingIssuesSettings === true).length;
        $scope.selectionLogic.refreshIfAllItemsSelected();
    };

    function loadCaregiverPayrolls(payrollBatchId) {
        $scope.isLoadingPayrollItems = true;
        const url = 'agencies/' + $rootScope.agencyId +
            '/agency_members/' + $rootScope.agencyMemberId +
            '/payroll_batches/' + payrollBatchId;
        DatabaseApi.get(url).then(function (res) {
            $scope.payrollBatch = res.data.payrollBatch;
            $scope.payrollItems = res.data.payrollItems;
            $scope.isDraft = $scope.payrollBatch.isDraft;
            initSelectionLogic($scope.payrollItems);
            initBillingPayrollTable($scope.payrollItems);
            $scope.isLoadingPayrollItems = false;
        }, function (err) {
            $scope.payrollItems = [];
            $scope.isLoadingPayrollItems = false;
            toaster.pop('error', 'Something went wrong');
        });
    }

    $scope.toggleBtnGroupValue = (paramName, toggledButton) => {
        switch ($scope.billingPayrollDetailsFilters[paramName]) {
            case "": {
                $scope.billingPayrollDetailsFilters[paramName] = toggledButton;
                break;
            }
            case null: {
                $scope.billingPayrollDetailsFilters[paramName] = !toggledButton;
                break;
            }
            default: {
                $scope.billingPayrollDetailsFilters[paramName] = toggledButton === $scope.billingPayrollDetailsFilters[paramName] ? "" : null;
                break;
            }
        }
    }

    const filterByMethods = {
        payrollVisitHasServiceCode: (payrollVisit, selectedServiceCodes) => selectedServiceCodes.indexOf(payrollVisit.serviceCodeId) !== -1,
        payrollVisitHasVisitType: (payrollVisit, selectedVisitTypes) => selectedVisitTypes.indexOf(payrollVisit.type) !== -1,
        payrollVisitIsNewOrOld: (payrollVisit, isOldVisit) => payrollVisit.oldVisit === isOldVisit,
        payrollVisitIsOvertime: (payrollVisit, isOvertimeVisit) => payrollVisit.overtime === isOvertimeVisit
    };

    function filterBillingPayrollTable() {
        if (!$scope.payrollItems) return;
        let filters = [];

        const selectedServiceCodes = $scope.billingPayrollDetailsFilters.serviceCodes.map((sc) => sc.id);
        if (selectedServiceCodes && selectedServiceCodes.length > 0) {
            filters.push(function (payrollVisit) { return filterByMethods.payrollVisitHasServiceCode(payrollVisit, selectedServiceCodes); });
        }

        const selectedVisitTypes = $scope.billingPayrollDetailsFilters.visitTypes.map((obj) => {
            return $scope.visitTypeOptions.find(function (type) { return type.id === obj.id; }).type;
        });
        if (selectedVisitTypes && selectedVisitTypes.length > 0) {
            filters.push(function (payrollVisit) { return filterByMethods.payrollVisitHasVisitType(payrollVisit, selectedVisitTypes); });
        }

        const isOldVisit = $scope.billingPayrollDetailsFilters.isOldVisit;
        if (isOldVisit !== null && isOldVisit !== "") {
            filters.push(function (payrollVisit) { return filterByMethods.payrollVisitIsNewOrOld(payrollVisit, isOldVisit); });
        }

        const isOvertimeVisit = $scope.billingPayrollDetailsFilters.isOvertimeVisit;
        if (isOvertimeVisit !== null && isOvertimeVisit !== "") {
            filters.push(function (payrollVisit) { return filterByMethods.payrollVisitIsOvertime(payrollVisit, isOvertimeVisit); });
        }

        let filteredPayrollItems = $scope.payrollItems;
        if (filters.length > 0) {
            filteredPayrollItems = filteredPayrollItems.filter(function (pv) {
                let isFiltered = true;
                for (let idx = 0; isFiltered && idx < filters.length; idx++) {
                    isFiltered = isFiltered && filters[idx](pv);
                }
                return isFiltered;
            });
        }

        initBillingPayrollTable(filteredPayrollItems);
    }

    function initBillingPayrollTable(items) {
        items.forEach(pv => {
            const contract = $scope.contracts.find(c => c.id === pv.contractTypeId);
            if (contract) {
                pv.contractName = contract.name;
            }

            const serviceCode = $scope.serviceCodes.find(s => s.id === pv.serviceCodeId);
            if (serviceCode) {
                pv.serviceCodeName = serviceCode.code;
            }

            pv.typeText = $scope.visitPayrollTypesMap[pv.type];
        });

        const options = {
            count: 25
        };

        $scope.filteredPayrollItems = items;
        updateFilteredPayrollItemsSelection();
        $scope.billingPayrollTable = new NgTableParams(options, {
            counts: [10, 25, 50, 100],
            dataset: items
        });
    };

    $scope.applyBillingPayrollGlobalSearch = function (term) {
        const filter = { $: term };
        if ($scope.billingPayrollTable) {
            angular.extend($scope.billingPayrollTable.filter(), filter);
        }
    };

    $scope.$watch('billingPayrollDetailsFilters', function () {
        filterBillingPayrollTable();
    }, true);

    const visitsServiceSet = new Set(["HOURLY", "LIVE-IN"]);

    function getTempRateV4(cPayrolls) {
        if (visitsServiceSet.has(cPayrolls.service) && cPayrolls.regularOvertime === "OVERTIME") {
            return (cPayrolls.rate / 1.5).toFixed(2);
        }
        return cPayrolls.rate;
    }

    function getRegHoursV4(cPayrolls) {
        if (visitsServiceSet.has(cPayrolls.service) && cPayrolls.regularOvertime === "REGULAR") {
            return cPayrolls.hoursAmount;
        }
        return "";
    }

    function getOTHoursV4(cPayrolls) {
        if (visitsServiceSet.has(cPayrolls.service) && cPayrolls.regularOvertime === "OVERTIME") {
            return cPayrolls.hoursAmount;
        }
        return "";
    }

    function getHours3CodeV4(cPayrolls) {
        if (visitsServiceSet.has(cPayrolls.service)) {
            return "";
        }
        return cPayrolls.service;
    }

    function getHours3AmountV4(cPayrolls) {
        if (visitsServiceSet.has(cPayrolls.service)) {
            return "";
        }
        return cPayrolls.hoursAmount;
    }

    $scope.downloadExcel = function (exportFileType) {
        $scope.isLoadingDownloadExcel = true;
        let caregiverPayrolls;
        let url = 'agencies/' + $rootScope.agencyId +
            '/agency_members/' + $rootScope.agencyMemberId +
            '/payroll_batches/' + $scope.payrollBatch.id +
            '/payroll_report_file';
        DatabaseApi.get(url).then(function (res) {
            const lines = res.data.lines;
            let csvContent = "";
            lines.forEach(function (row) {
                csvContent += row + "\r\n";
            });
            const encodedUri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(universalBOM+csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            if (exportFileType === "csv") {
                link.setAttribute("download", "medflyt-payroll-visits-export.csv");
            } else if (exportFileType === "xls") {
                link.setAttribute("download", "medflyt-payroll-visits-export.xls");
            }
            document.body.appendChild(link);

            link.click();

            $scope.isLoadingDownloadExcel = false;
        }, function (err) {
            $scope.isLoadingDownloadExcel = false;
            toaster.pop('error', 'Something went wrong');
        });
    }

    $scope.onCaregiverClick = function (caregiverId, modal) {
        $rootScope.openCaregiverModal(caregiverId);
    }

    $scope.preOpenPatientModal = function (patientId) {
        if (!patientId) return;
        $rootScope.openPatientModal(patientId);
    }

    $scope.secondsToLabel = function (seconds) {
        if (!seconds && seconds !== 0) return '';
        const duration = moment.duration(Math.abs(seconds), 'seconds');
        const hours = Math.floor(duration.asHours());
        if (hours > 0) duration.subtract(hours, "hours");
        let minutes = Math.floor(duration.asMinutes());
        if (minutes < 10) minutes = '0' + minutes;
        const sign = Math.sign(seconds) === -1 ? '-' : '';
        return `${sign}${hours}:${minutes} hr`;
    }

    $scope.getSelectedCount = () => {
        if (!Boolean($scope.selectionLogic)) {
            return "Loading...";
        }
        return $scope.selectionLogic.countSelected();
    }

    $scope.confirmPayrollBatch = () => {
        const modal = mfModal.create({
            subject: "Payroll Batch",
            message: `Are you sure you want to confirm current payroll batch?`,
            cancelLabel: "Cancel",
            confirmLabel: "Yes, Confirm",
            onConfirm: () => {
                modal.setLoading(true);

                const selectedItems = $scope.selectionLogic.getSelectedItems().map(i => i.id);
                const exludedItems = $scope.payrollItems
                    .filter(pv => !selectedItems.includes(pv.id));
                const body = {
                    excludedPayrollItems: {
                        visits: [],
                        travelTime: [],
                        pto: [],
                        onlineTraining: [],
                        classroomTraining: []
                    }
                };
        
                for (const row of exludedItems) {
                    switch (row.type) {
                        case "VISIT":
                        case "SOH":
                            body.excludedPayrollItems.visits.push(row.id);
                            break;
                        case "TRAVEL_TIME":
                            body.excludedPayrollItems.travelTime.push(row.id);
                            break;
                        case "PTO":
                            body.excludedPayrollItems.pto.push(row.id);
                            break;
                        case "ONLINE_TRAINING":
                            body.excludedPayrollItems.onlineTraining.push(row.id);
                            break;
                        case "IN_CLASS":
                            body.excludedPayrollItems.classroomTraining.push(row.id);
                            break;
                        default:
                            break;
                    }
                }

                const url = wildcard(
                    "agencies/:agencyId/agency_members/:agencyMemberId/payroll_batches/:payrollBatchId",
                    $rootScope.agencyId,
                    $rootScope.agencyMemberId,
                    $scope.payrollBatch.id
                );

                $scope.isConfirmLoading = true;
                DatabaseApi.put(url, body).then(function (res) {
                    loadCaregiverPayrolls($scope.payrollBatch.id);
                    $scope.isConfirmLoading = false;
                    clearFilters();
                    toaster.pop("success", "Payroll batch confirmed successfully");
                    modal.close();
                }, function (err) {
                    $scope.isConfirmLoading = false;
                    toaster.pop('error', 'Failed to confirm payroll batch');
                }).finally(() => {
                    modal.update({ isLoading: false });
                });
            }
        });
    }

    // The draft item tables a payroll row belongs to, as named by the remove endpoint.
    const draftItemTypeOf = (row) => {
        switch (row.type) {
            case "VISIT":
            case "SOH":
                return "VISIT";
            case "TRAVEL_TIME":
            case "PTO":
            case "ONLINE_TRAINING":
            case "IN_CLASS":
                return row.type;
            default:
                return null;
        }
    };

    $scope.removeDraftItem = (row) => {
        const itemType = draftItemTypeOf(row);
        if (!$scope.isDraft || itemType === null || row.isRemoving) {
            return;
        }

        const url = wildcard(
            "agencies/:agencyId/agency_members/:agencyMemberId/payroll_batches/:payrollBatchId/items/:itemType/:itemId",
            $rootScope.agencyId,
            $rootScope.agencyMemberId,
            $scope.payrollBatch.id,
            itemType,
            row.id
        );

        row.isRemoving = true;
        DatabaseApi.delete(url).then(function () {
            // One payroll item can show as several rows (e.g. a visit's regular and overtime lines).
            const isRemoved = (item) => item.id === row.id && draftItemTypeOf(item) === itemType;
            const removed = $scope.payrollItems.filter(isRemoved);
            const remaining = $scope.payrollItems.filter(item => !isRemoved(item));

            if ($scope.payrollBatch.totalAmount) {
                $scope.payrollBatch.totalAmount -= removed.reduce((sum, item) => sum + (item.total || 0), 0);
            }
            if (itemType === "VISIT" && $scope.payrollBatch.totalVisits &&
                !remaining.some(item => item.visitInstanceId === row.visitInstanceId && draftItemTypeOf(item) === "VISIT")) {
                $scope.payrollBatch.totalVisits -= 1;
            }

            const previousTable = $scope.billingPayrollTable;
            $scope.payrollItems = remaining;
            rebuildSelectionLogic(remaining);
            filterBillingPayrollTable();

            // Stay where the user was, rather than jumping back to the first page.
            if (previousTable) {
                const table = $scope.billingPayrollTable;
                const lastPage = Math.max(1, Math.ceil(table.settings().dataset.length / previousTable.count()));
                table.filter(previousTable.filter());
                table.sorting(previousTable.sorting());
                table.count(previousTable.count());
                table.page(Math.min(previousTable.page(), lastPage));
            }
            toaster.pop("success", "Removed from draft");
        }, function () {
            row.isRemoving = false;
            toaster.pop("error", "Failed to remove the item from the draft");
        });
    };

    $scope.handlePayrollItemClick = (item) => {
        switch(item.type) {
            case 'VISIT': {
                $rootScope.openVisitInstanceModal(item.visitInstanceId)
                break;
            }
            case 'PTO': {
                const url = wildcard(
                    "agencies/:agencyId/agency_members/:agencyMemberId/payroll_pto/:payrollPtoId",
                    $rootScope.agencyId,
                    $rootScope.agencyMemberId,
                    item.id // AS payroll_pto_id
                  );
                DatabaseApi.get(url).then(function (res) {
                    const ptoInstance = res.data;

                    const ptoLabel = $scope.caregiverPTOLabels.find(ptoLabel => ptoLabel.id === ptoInstance.labelId);
                    const newScope = $scope.$new(true);

                    newScope.ptoEventForm = ptoInstance;
                    newScope.ptoEventForm.pto = ptoInstance;
                    newScope.ptoEventForm.visitInstance.durationInMinutes = ptoInstance.duration;
                    const startTime = newScope.ptoEventForm.visitInstance.startTime;
                    const endTime = newScope.ptoEventForm.visitInstance.endTime;
                    newScope.ptoEventForm.visitInstance.originalStart = moment(startTime.toJSON ? startTime.toJSON() : startTime);
                    newScope.ptoEventForm.visitInstance.originalEnd = moment(endTime.toJSON ? endTime.toJSON() : endTime);
                    newScope.ptoEventForm.label = ptoLabel ? { id: ptoLabel.id, text: ptoLabel.labelText } : '';
                    // Resolved for this one modal; blank until it lands, as it was
                    // while the patient dictionary was still downloading.
                    newScope.ptoEventForm.visitInstance.titleName = '';
                    patientLookupService
                        .byId(ptoInstance.visitInstance.patientId)
                        .then((patient) => {
                            newScope.ptoEventForm.visitInstance.titleName =
                                patient === null ? '' : patient.displayName;
                        });
                    newScope.visitInstances = [ptoInstance.visitInstance];
                    newScope.viewModeOnly = true;
                    newScope.caregiverId = ptoInstance.caregiverId;

                    const modalInstance = $uibModal.open({
                      templateUrl: "admin/views/visit-instance-pto-modal.html",
                      size: "md",
                      controller: "visitInstancePTOModalCtrl",
                      windowTopClass: "PTO-modal",
                      scope: newScope,
                    });
                }, function (err) {
                    toaster.pop('error', 'Something went wrong', 'Could not open caregiver pto instance');
                });
                break;
            }
            default: return;
        }
    }

    $rootScope.$on("got_contract_types", function (event) {
        $scope.contracts = DatabaseApi.contractTypes();
    });

    $rootScope.$on("got_service_codes", function (event) {
        $scope.serviceCodes = DatabaseApi.activeServiceCodes();
        $scope.serviceCodesOptions = $scope.serviceCodes.map(sc => ({ id: sc.id, label: sc.code }));
    });

    $rootScope.$on("got_pto_labels", function (event) {
        $scope.caregiverPTOLabels = DatabaseApi.caregiverPtoLabels();
    });

    $scope.caregiverPTOLabels = DatabaseApi.caregiverPtoLabels();

    const clearFilters = () => {
        $scope.billingPayrollDetailsFilters = {
            serviceCodes: [],
            visitTypes: [],
            isOldVisit: "",
            isOvertimeVisit: ""
        };
    }

    $scope.testObj = {};

    $scope.$watch("testObj.uploadedFile", function () {
      if ($scope.testObj.uploadedFile && $scope.testObj.uploadedFile.name) {
        $scope.uploadPayrollPreview($scope.testObj.uploadedFile)
      }
    });

    $scope.uploadPayrollPreview = function (file) {
        var formData = new FormData();
        formData.append("file", file, file.name);

        var url =
            Consts.api +
            "agencies/" +
            $rootScope.agencyId +
            "/agency_members/" +
            $rootScope.agencyMemberId +
            "/payroll_batches/" +
            $scope.payrollBatch.id +
            "/upload_payroll_preview_for_deduction_update";
        $http({
            url: url,
            method: "POST",
            data: formData,
            headers: { "Content-Type": undefined }
        }).then(
            function (response) {
                $scope.uploadedFile = null;
                toaster.pop("success", "Success", "File Uploaded");
            },
            function (response) {
                $scope.uploadedFile = null;
                toaster.pop("error", "Something Went Wrong", "Please try again");
            }
        );
    }

    $scope.isUploadingEmployees = false;
    $scope.hasUploadedEmployees = false;

    $scope.uploadEmployees = function () {
        if ($scope.isUploadingEmployees) return;

        $scope.isUploadingEmployees = true;
        var url =
            Consts.api +
            "agencies/" +
            $rootScope.agencyId +
            "/agency_members/" +
            $rootScope.agencyMemberId +
            "/payroll_batches/" +
            $scope.payrollBatch.id +
            "/upload_caregiver_info";
        $http({
            url: url,
            method: "POST",
            data: {},
            headers: { "Content-Type": undefined }
        }).then(
            function (response) {
                const message = getEmployeeUploadResponseMessage(response.data);
                
                if (response.data.new > 0 || response.data.updated > 0) {
                    toaster.pop("success", "Success", message);
                    $scope.hasUploadedEmployees = true;
                } else {
                    toaster.pop("error", "No Employees Uploaded", message);
                }

                $scope.isUploadingEmployees = false;
            },
            function (response) {
                $scope.isUploadingEmployees = false;

                toaster.pop("error", "Something Went Wrong", getEmployeeUploadResponseMessage(response.data));
            }
        );
    }

    initialize();
};

function getEmployeeUploadResponseMessage(response) {
    const sections = [];
    const lines = [];

    if (response.new > 0 || response.updated > 0) {
        sections.push("New Employees: " + response.new);
        sections.push("Updated Employees: " + response.updated);
    }

    if (response.validationErrors.length > 0) {
        sections.push("Validation errors:\n" + response.validationErrors.join("\n"));
    }

    if (response.uploadErrors.length > 0) {
        sections.push("Upload errors:\n" + response.uploadErrors.join("\n"));
    }

    return sections.join("\n\n");
}
